import { apiClient } from '@/lib/api/api-client'

const TRANSFER_ENDPOINT = '/transfer'

export const transferRequestApi = {
  getTransferRequests: (params?: { status?: string; departmentId?: string }) =>
    apiClient.get<any>(TRANSFER_ENDPOINT, { params }),

  getActiveTransferRequests: (params?: { status?: string; departmentId?: string }) =>
    apiClient.get<any>(`${TRANSFER_ENDPOINT}/active`, { params }),

  getTransferRequest: (id: string) => apiClient.get<any>(`${TRANSFER_ENDPOINT}/${id}`),

  createTransferRequest: (payload: any) => apiClient.post<any>(TRANSFER_ENDPOINT, payload),

  createBorrowTransferRequest: (payload: any) => apiClient.post<any>(`${TRANSFER_ENDPOINT}/borrow`, payload),

  createReturnTransferRequest: (payload: any) => apiClient.post<any>(`${TRANSFER_ENDPOINT}/return`, payload),

  approveTransferRequest: (id: string, payload?: any) =>
    apiClient.patch<any>(`${TRANSFER_ENDPOINT}/${id}/approve`, payload),

  rejectTransferRequest: (id: string, payload?: any) =>
    apiClient.patch<any>(`${TRANSFER_ENDPOINT}/${id}/reject`, payload),

  scheduleTransferRequest: (id: string, payload?: any) =>
    apiClient.patch<any>(`${TRANSFER_ENDPOINT}/${id}/schedule`, payload),

  deliverTransferRequest: (id: string, payload?: any) =>
    apiClient.patch<any>(`${TRANSFER_ENDPOINT}/${id}/deliver`, payload),

  markTransferPickupReady: (id: string, payload?: any) =>
    apiClient.patch<any>(`${TRANSFER_ENDPOINT}/${id}/pickup-ready`, payload),

  receiveTransferRequest: (id: string, payload?: any) =>
    apiClient.patch<any>(`${TRANSFER_ENDPOINT}/${id}/receive`, payload),

  getTransferRequestLogs: (id: string) => apiClient.get<any>(`${TRANSFER_ENDPOINT}/${id}/logs`),
}
